import { useEffect } from 'react';
import { trackPageView } from 'utils/tracking/pageTracking';

const usePageTracking = (pageName) => {
  useEffect(() => {
    trackPageView(pageName);
  }, [pageName]);
};

export default usePageTracking;
